var _jsxFileName = "/Users/brentvatne/coding/react-navigation-stack/src/views/Header/BackButtonWeb.tsx";
import * as React from 'react';
export default function BackButton(_ref) {
  var tintColor = _ref.tintColor;
  return React.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    }
  }, React.createElement("path", {
    fill: tintColor,
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  }));
}